import React from 'react';
import { ModalContent, ModalHeader, Typography } from 'common/components';

export const Repair = () => (
  <>
    <ModalHeader title="Ремонт с нуля: всё включено" />
    <ModalContent variant="simple">
      <Typography adaptive={false} variant="m" size="body_long">
        Мы&nbsp;возьмеём на&nbsp;себя все этапы&nbsp;&mdash; от&nbsp;замеров и&nbsp;дизайн-проекта
        до&nbsp;выбора материалов, доставки и&nbsp;установки. Вам не&nbsp;нужно думать о&nbsp;сроках,
        закупках и&nbsp;координации&nbsp;&mdash; наслаждайтесь качественным ремонтом без лишних хлопот.
      </Typography>
    </ModalContent>
  </>
);
